module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-06-6d052c4062869acf17fbb6f487fd0f99.png";